var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup',{ref:"popup",attrs:{"show":_vm.show,"title":_vm.data.name,"footer":false},on:{"close":_vm.close}},[_c('div',{staticClass:"desc-detail"},[_vm._v(" "+_vm._s(_vm.data.desc)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }